import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_ENDPOINT; 

export const fetchMe = createAsyncThunk(
    'me',
    async (_, { getState, rejectWithValue }) => {
        try{
            const token = getState().auth.token || localStorage.getItem('authToken');

            const response = await axios.get(`${API_URL}/me`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            
            return response.data.data;  
        } catch (error){
            return rejectWithValue(error.response.data);
        }
    }
);

const meSlice = createSlice({
    name: 'me',
    initialState: {
        me: [],
        isLoading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchMe.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(fetchMe.fulfilled, (state, action) => {
                state.isLoading = false;
                state.me = action.payload;
            })
            .addCase(fetchMe.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            });
    },
})

export default meSlice.reducer;
